module.exports = __webpack_public_path__ + "img/check-pink.5d5505d0.svg";